module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive--dark-7bee3e65f324ea378f5c063108fd277c.png";